/** Bounded four-connected flood fill. Tolerance includes light antialiased edges. */
export function floodFill(
  data: Uint8ClampedArray,
  width: number,
  height: number,
  x: number,
  y: number,
  hex: string,
) {
  const start =
    Math.min(height - 1, Math.max(0, Math.floor(y))) * width +
    Math.min(width - 1, Math.max(0, Math.floor(x)));
  const target = [data[start * 4]!, data[start * 4 + 1]!, data[start * 4 + 2]!];
  const color = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
  if (color.every((c, i) => c === target[i])) return;
  const seen = new Uint8Array(width * height);
  const queue = new Int32Array(width * height);
  let head = 0,
    tail = 1;
  queue[0] = start;
  seen[start] = 1;
  const visit = (p: number) => {
    if (!seen[p]) {
      seen[p] = 1;
      queue[tail++] = p;
    }
  };
  while (head < tail) {
    const p = queue[head++]!;
    const offset = p * 4;
    if (target.some((c, i) => Math.abs(data[offset + i]! - c) > 40)) continue;
    for (let i = 0; i < 3; i++) data[offset + i] = color[i]!;
    data[offset + 3] = 255;
    if (p % width > 0) visit(p - 1);
    if (p % width < width - 1) visit(p + 1);
    if (p >= width) visit(p - width);
    if (p < width * (height - 1)) visit(p + width);
  }
}
